var _defs, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcons8User(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 12.801,
    height: 16,
    viewBox: "0 0 12.801 16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #2A60BC;\n      }\n    "))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "icons8-user",
    className: "cls-1",
    d: "M14.4,4a4,4,0,1,0,4,4A4.009,4.009,0,0,0,14.4,4Zm0,1.2A2.8,2.8,0,1,1,11.6,8,2.791,2.791,0,0,1,14.4,5.2ZM9.591,13.6A1.6,1.6,0,0,0,8,15.191V15.8a3.728,3.728,0,0,0,2.123,3.225A9,9,0,0,0,14.4,20a9,9,0,0,0,4.277-.975A3.866,3.866,0,0,0,20.7,16.4h.1V15.191A1.6,1.6,0,0,0,19.209,13.6Zm0,1.2h9.617a.383.383,0,0,1,.392.391V15.2h0v.6a2.437,2.437,0,0,1-1.5,2.175,7.974,7.974,0,0,1-3.7.825,7.974,7.974,0,0,1-3.7-.825A2.437,2.437,0,0,1,9.2,15.8v-.609A.383.383,0,0,1,9.591,14.8Z",
    transform: "translate(-8 -4)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcons8User);
export default __webpack_public_path__ + "static/media/icons8-user.4ef3e4c0a637b72fc644c3ffa2700c38.svg";
export { ForwardRef as ReactComponent };